export const isValidUrl = value => new RegExp(/^(http(s)?:\/\/)\w+[^\s]+(\.[^\s]+){1,}$/).test(value);

export default isValidUrl;
//# sourceMappingURL=isValidUrl.js.map
